module.exports = __webpack_public_path__ + "img/BNP Paribas.8c43392f.png";